<template>
  <div style="height: 450px">
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Select v-model="selectedYear" :options="yearOptions" form-group-id="Year" placeholder="year" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12 pt-1">
        <b-button v-if="isRecalculationFlag" variant="primary" size="lg" class="pdf-btn mt-4" disabled>
          <b-spinner small />
          {{ 'recalculating' | i18n }} - {{ progress }}%
        </b-button>
        <b-button v-else variant="primary" size="lg" class="pdf-btn mt-4" :disabled="!selectedYear" @click="recalculateData">
          {{ 'recalculate' | i18n }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Select from '../../../common/select/index';
import { NotificationMixin } from '../../../../../mixins';
import api from '../../../../api';

export default {
  name: 'RecalculationAVG',
  components: { Select },
  mixins: [NotificationMixin],
  data: function () {
    return {
      selectedYear: '',
      yearOptions: [],
      isRecalculationFlag: false,
      intervalIndex: null,
      progress: 0,
    };
  },
  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.checkRecalculation();
    this.intervalIndex = setInterval(async () => {
      this.checkRecalculation();
    }, 5000);
  },
  destroyed() {
    if (this.intervalIndex) {
      clearInterval(this.intervalIndex);
    }
  },
  methods: {
    async checkRecalculation() {
      try {
        const data = await api.recalculation.get();
        const active = data.find((d) => d.isActive);
        if (active) {
          this.isRecalculationFlag = true;
          this.progress = active.progress;
        } else {
          if (this.isRecalculationFlag) {
            this.isRecalculationFlag = false;
            this.progress = 0;
            this.showNotification({
              type: 'success',
              title: this.$translate('success'),
              message: this.$translate('recalculation_have_been_success'),
            });
          }
        }
      } catch (error) {
        this.showNotification({
          type: 'error',
          title: this.$translate('error'),
          message: error.message,
        });
      }
    },
    async recalculateData() {
      try {
        this.isRecalculationFlag = true;
        await api.recalculation.recalculate({ year: this.selectedYear });
      } catch (error) {
        this.showNotification({
          type: 'error',
          title: this.$translate('error'),
          message: error.message,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 30px !important;
}
</style>
